import * as PROJECT_CODE from '../../constants/projectCode';
import firebase from '../../lib/firebase.prod';

const firebaseRef = firebase.database();

// export default async function getCoBrokers() {
// 	let getAllCoBrokers = firebase.functions().httpsCallable('getAllCoBrokers');
// 	let coBrokers = await getAllCoBrokers();
// 	return coBrokers.data;
// }

export default async function getCoBrokers(callback) {
	firebaseRef
		.ref('/kavtek_coBrokers/' + PROJECT_CODE.projectCode)
		.on('value', async (snapshot) => {
			let coBrokersArr = [];
			let coBrokersParent = snapshot.val();
			if (coBrokersParent) {
				for (let key of Object.keys(coBrokersParent)) {
					let assignedSalesAgentName = '';
					if (coBrokersParent[key].assignedSalesAgent) {
						await firebaseRef
							.ref(
								'/kavtek_sales_agents/' +
									PROJECT_CODE.projectCode
							)
							.orderByChild('createrID')
							.equalTo(coBrokersParent[key].assignedSalesAgent)
							.once('value', (snapshot) => {
								console.log('getCobrokers', snapshot.val());

								var salesAgentParent = snapshot.val();

								var salesAgentParentKeys =
									salesAgentParent &&
									Object.keys(salesAgentParent);

								var salesAgentArr = [];

								salesAgentParentKeys?.forEach((x) => {
									salesAgentArr.push(salesAgentParent[key]);
								});
								let salesAgents = salesAgentArr?.filter(
									(item) => item
								);
								if (salesAgents.length > 0) {
									assignedSalesAgentName =
										salesAgents[0].name;
								}
							});
					}

					let coBrokerFullName = '';
					if (coBrokersParent[key].userId) {
						await firebaseRef
							.ref('/users/' + coBrokersParent[key].userId)
							.once('value', (snapshot) => {
								let user = snapshot.val();
								if (user) {
									coBrokerFullName = user.fullName;
								}
							});
					}

					let coBrokerObj = {
						...coBrokersParent[key],
						coBrokerId: key,
						assignedSalesAgentName: assignedSalesAgentName,
						name: coBrokerFullName,
					};
					coBrokersArr.push(coBrokerObj);
				}
			}

			console.log('coBrokersArr', coBrokersArr);
			callback(coBrokersArr);
		});
}
